export default __webpack_public_path__ + "images/G4.1bde9fe.png";